<template>
    <ds-modal
        class="phone-alert-modal"
        :is-open="isOpen"
        size="med"
        @close="close"
    >
        <div class="body">
            <header class="phone-types-modal-header">
                <ds-icon-button data-qa="close-icon" name="x" @click="close" />
            </header>

            <ds-illustration name="setup-messenger-color" />

            <div class="content">
                <h3 class="title">
                    {{ optionsAvoidText }}
                </h3>

                <p class="title-description">
                    {{ avoidRecipientMsg }}
                </p>

                <ul class="details-list">
                    <li class="description">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="recentMobileText" />
                    </li>
                    <li class="description">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="verifyText" />
                    </li>
                    <li class="description">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="considerText" />
                    </li>
                </ul>
            </div>

            <div class="done-button">
                <ds-filled-button data-qa="done-button" @click="close">
                    {{ okText }}
                </ds-filled-button>
            </div>
        </div>
    </ds-modal>
</template>
<script>
export default {
    props: {
        isOpen: Boolean,
    },

    data() {
        return {
            optionsAvoidText: '',
            avoidRecipientMsg: '',
            recentMobileText: '',
            verifyText: '',
            considerText: '',
            okText: '',
        };
    },

    created() {
        if (window.keapI18nMap !== undefined) {
            this.optionsAvoidText = window.keapI18nMap['funnel.campaign.communications.see.options.avoid.message'];
            this.avoidRecipientMsg = window.keapI18nMap['funnel.campaign.communications.see.options.avoid.recipients.message'];
            this.recentMobileText = window.keapI18nMap['funnel.campaign.communications.see.options.recent.mobile.number'];
            this.verifyText = window.keapI18nMap['funnel.campaign.communications.see.options.verify.text'];
            this.considerText = window.keapI18nMap['funnel.campaign.communications.see.options.consider.text'];
            this.okText = window.keapI18nMap['funnel.campaign.communications.see.options.ok.text'];
        } else {
            this.optionsAvoidText = 'How to: Avoid sending multiple texts';
            this.avoidRecipientMsg = 'To avoid sending your recipients a text message on more than 1 phone number:';
            this.recentMobileText = 'Take a closer look at your phone data to verify you have the <strong>most recent mobile number</strong> for your contacts';
            this.verifyText = 'Verify you only have <strong>1 phone number marked as “mobile”</strong> on your contact records';
            this.considerText = ' Consider <strong>removing other phone types</strong> (work, other, home) to reduce the number of recipients who may receive multiple texts';
            this.okText = 'Ok, got it';
        }
    },

    methods: {
        close() {
            this.$emit('close');
        },
    },

};
</script>

<style lang="scss" scoped>
.phone-alert-modal {
    --modal-padding: 0;
}

.close-button {
    align-self: flex-start;
    padding: $spacing-075;
}

.body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.title {
    text-align: center;
    font-size: $font-size-xl;
    font-weight: $font-weight-bold;
    padding: $spacing-200 $spacing-200 $spacing-100;
    color: $color-text-normal;
}

.content {
    display: flex;
    flex-direction: column;
    padding: 0 $spacing-700;
}

.phone-types-modal-header {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: $spacing-100;
}

.description {
    font-size: $font-size-md;
    line-height: $line-height-lg;
    padding: $spacing-200 0;
}

.suggestion-row {
    display: flex;
    padding: 0 $spacing-100 $spacing-200;
}

.title-description {
    padding: 0 5rem;
    text-align: center;
    font-size: $font-size-md;
    line-height: $line-height-lg;
    margin: 0;
}

.done-button {
    margin: $spacing-300 0 $spacing-500;
}

.details-list {
    margin: $spacing-150 0;
    padding: 0 $spacing-800;
    list-style: initial;
}
</style>
